/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SheetId } from "../../commons/types/SheetId";
import { RunbookId } from "../../commons/types/RunbookId";
export const RunRunbookJobConfig = core.serialization.object({
    sourceSheetId: SheetId,
    runbookId: RunbookId,
});
